import React, { useEffect, useState } from 'react';
import api from '../api/client';
import { useAuth } from '../context/AuthContext';

// Schermata a schermo intero mostrata al login ai collaboratori (utenti collegati a un Dipendente
// attivo) che non hanno ancora preso visione dell'informativa privacy corrente — stesso schema di
// CambiaPasswordObbligatoria. È una presa visione (base giuridica = contratto/obbligo di legge),
// non un consenso: il testo arriva dal server, unica fonte anche per la copia inviata via email.
export default function InformativaCollaboratori() {
  const { user, updateUser, logout } = useAuth();
  const [informativa, setInformativa] = useState(null);
  const [letta, setLetta] = useState(false);
  const [error, setError] = useState('');
  const [loading, setLoading] = useState(false);

  useEffect(() => {
    api.get('/auth/informativa-collaboratori')
      .then(r => setInformativa(r.data))
      .catch(err => setError(err.response?.data?.error || 'Impossibile caricare l\'informativa'));
  }, []);

  const conferma = async () => {
    setError('');
    setLoading(true);
    try {
      const r = await api.post('/auth/informativa-collaboratori/presa-visione');
      alert(r.data.email_inviata
        ? `Grazie! Ti abbiamo inviato una copia dell'informativa a ${r.data.email}.`
        : 'Grazie, presa visione registrata. Non siamo riusciti a inviarti la copia via email: puoi chiederla allo staff.');
      updateUser({ informativa_collab_richiesta: false });
    } catch (err) {
      setError(err.response?.data?.error || 'Errore');
    } finally { setLoading(false); }
  };

  return (
    <div style={s.page}>
      <div style={s.card}>
        <div style={s.logo}>B-CHEERS ASD</div>
        <div style={s.sub}>PRIVACY COLLABORATORI</div>
        <p style={s.desc}>Ciao <strong style={{ color:'#F4600C' }}>{user?.nome}</strong>, prima di continuare leggi come trattiamo i tuoi dati personali per la gestione della collaborazione.</p>

        <div style={s.testo}>
          {informativa
            ? <div dangerouslySetInnerHTML={{ __html: informativa.html }}/>
            : !error && <div style={{ color:'var(--text-dim)' }}>Caricamento...</div>}
        </div>

        <label style={s.check}>
          <input type="checkbox" checked={letta} onChange={e=>setLetta(e.target.checked)} style={{ accentColor:'#F4600C', marginTop:'3px' }}/>
          <span>Dichiaro di aver letto e compreso l'informativa sul trattamento dei miei dati personali.</span>
        </label>
        {error && <div style={s.error}>{error}</div>}
        <button type="button" onClick={conferma} disabled={!letta || !informativa || loading}
          style={{ ...s.btn, opacity: (!letta || !informativa || loading) ? 0.5 : 1, cursor: (!letta || !informativa) ? 'not-allowed' : 'pointer' }}>
          {loading ? 'REGISTRAZIONE...' : 'CONFERMO E CONTINUO'}
        </button>
        <div style={s.footer}>
          Riceverai una copia via email. <button type="button" onClick={logout} style={s.linkBtn}>Esci</button>
        </div>
      </div>
    </div>
  );
}

const s = {
  page:   { minHeight:'100vh', background:'var(--bg)', display:'flex', alignItems:'center', justifyContent:'center', padding:'20px' },
  card:   { background:'var(--bg)', border:'1px solid var(--border)', borderRadius:'16px', padding:'36px 32px', width:'100%', maxWidth:'720px', boxSizing:'border-box' },
  logo:   { fontFamily:"'Barlow Condensed'", fontSize: 'var(--font-size-title)', fontWeight:'800', color:'#F4600C', letterSpacing:'3px', textAlign:'center', marginBottom:'4px' },
  sub:    { fontSize:'var(--font-size-xs)', fontWeight:'700', color:'var(--text-dim)', letterSpacing:'2px', textAlign:'center', marginBottom:'20px' },
  desc:   { color:'var(--text-dim)', fontSize:'var(--font-size-sm)', marginBottom:'16px', lineHeight:'1.6', textAlign:'center' },
  testo:  { background:'var(--bg-input)', border:'1px solid var(--border2)', borderRadius:'10px', padding:'16px 20px', maxHeight:'50vh', overflowY:'auto', fontSize:'var(--font-size-sm)', lineHeight:'1.55', color:'var(--text)', marginBottom:'16px' },
  check:  { display:'flex', alignItems:'flex-start', gap:'8px', fontSize:'var(--font-size-sm)', marginBottom:'14px', cursor:'pointer' },
  error:  { background:'#EF444420', border:'1px solid #EF444440', borderRadius:'8px', padding:'10px 14px', color:'#EF4444', fontSize:'var(--font-size-sm)', fontWeight:'600', marginBottom:'12px' },
  btn:    { width:'100%', background:'#F4600C', color:'#fff', border:'none', borderRadius:'10px', padding:'14px', fontSize:'var(--font-size-sm)', fontWeight:'700', letterSpacing:'1px' },
  footer: { textAlign:'center', marginTop:'16px', fontSize:'var(--font-size-sm)', color:'var(--text-dim)' },
  linkBtn:{ background:'none', border:'none', color:'#F4600C', fontWeight:'700', cursor:'pointer', fontSize:'var(--font-size-sm)' },
};
